<button type="button" class="swal2-close" aria-label="Close" (click)="modal.dismiss()">
  <span aria-hidden="true">&times;</span>
</button>

<div class="d-flex flex-column align-items-center p-4">
  <img src="/assets/img/patientlynk/PNG/logo-dark.png" style="max-width: 300px" />

  <p class="my-5">
    <span [innerHTML]="'banner.popupCopy' | transloco: { site: theme.name }"></span>
    <a href="https://www.cms.gov/newsroom/fact-sheets/interoperability-and-patient-access-fact-sheet"
       target="_blank" class="text-nowrap ml-2" transloco="banner.learnMore"></a>
  </p>

  <div class="mx-auto my-4">
    <input type="checkbox" id="dontShowAgain" (change)="onDontShowAgainChange($event)"
           [ngModel]="(popupSettings | async)?.dontShow"/>
    <label for="dontShowAgain">
      <span transloco="banner.dontShowAgain">Don't show this next time</span>,
      <span transloco="banner.dontShowAgainPL">open patientLynk directly.</span>
    </label>
  </div>

  <div class="d-flex flex-column align-items-center mx-auto">
    <button class="ab_button filled text-nowrap w-auto"
            transloco="banner.goToPL" (click)="openExternal()"></button>
    <a class="mt-4" transloco="banner.backToWL" (click)="modal.dismiss()"
       [translocoParams]="{ site: theme.name }"></a>
  </div>
</div>
